import { makeStyles } from '@material-ui/core/styles';
import globalStyles from '../../theme/globalStyles.js';

const useGlobalStyles = makeStyles(globalStyles);

export default useGlobalStyles;
